export const paths = {
  auth: {
    login: "/auth/login",
    register_reseller: "/register-reseller",
  },
  dashboard: "/dashboard",
  quotation: {
    list: "/quotation",
    detail: "/quotation/:id",
  },
  profile: {
    admin: "/profile-admin",
    reseller: "/profile-reseller",
  },
  examples: {
    list: "/examples",
    create: "/examples/create",
    detail: "/examples/:id",
    edit: "/examples/:id/edit",
  },
  transactions: {
    list: "/transactions",
    detail: "/transactions/:id",
  },
  transactionReseller: {
    list: "/transaction-reseller",
  },
  transactionResellerAdmin: {
    list: "/admin/transaction-reseller",
    detail: "/admin/transaction-reseller/:id",
  },
  userManagement: {
    users: {
      list: "/user-managements/users",
      detail: "/user-managements/users/:id",
      edit: "/user-managements/users/:id/edit",
      create: "/user-managements/users/create",
    },
    admins: {
      list: "/user-managements/admins",
      detail: "/user-managements/admins/:id",
      edit: "/user-managements/admins/:id/edit",
      create: "/user-managements/admins/create",
    },
    resellers: {
      list: "/user-managements/resellers",
      detail: "/user-managements/resellers/:id",
      edit: "/user-managements/resellers/:id/edit",
    },
  },
  contentManagement: {
    articles: {
      list: "/content-managements/articles",
      detail: "/content-managements/articles/:id",
      edit: "/content-managements/articles/:id/edit",
      create: "/content-managements/articles/create",
    },
    banners: {
      list: "/content-managements/banners",
      detail: "/content-managements/banners/:id",
      edit: "/content-managements/banners/:id/edit",
      create: "/content-managements/banners/create",
    },
    testimoni: {
      list: "/content-managements/testimoni",
      detail: "/content-managements/testimoni/:id",
      edit: "/content-managements/testimoni/:id/edit",
      create: "/content-managements/testimoni/create",
    },
  },
  products: {
    warehouse_stock: {
      list: "/products/warehouse-stock",
      detail: "/products/warehouse-stock/:id",
      edit: "/products/warehouse-stock/:id/edit",
      create: "/products/warehouse-stock/create",
    },
    reseller_stock: {
      list: "/products/reseller-stock",
      detail: "/products/reseller-stock/:id",
      edit: "/products/reseller-stock/:id/edit",
      create: "/products/reseller-stock/create",
    },
    product_categories: {
      list: "/products/product-categories",
      edit: "/products/product-categories/:id/edit",
      create: "/products/product-categories/create",
    },
    bird_types: {
      list: "/products/bird-types",
      edit: "/products/bird-types/:id/edit",
      create: "/products/bird-types/create",
    },
  },
};
